<template>
  <a
    class="external-link"
    :href="href"
    target="_blank"
  >
    <component
      :is="tag"
      :class="[
        'external-link__text',
        {
          truncate: isTruncated,
          'truncate-start': truncateStart,
        },
      ]"
    >
      <slot>{{ text }}</slot>
    </component>

    <tm-icon
      v-if="withIcon"
      class="external-link__icon"
      name="tmi-open-in-new"
      :size="iconSize ?? 'large'"
    />
  </a>
</template>

<script lang="ts" setup>
import { computed } from '@/composition/vue/compositionApi'

import TmIcon from '@/components/shared/TmIcon.vue'
import type { IconSize } from '@/components/shared/types'

const {
  tag = 'span',
  truncateStart,
  noTruncate,
} = defineProps<{
  text?: string
  href: string
  withIcon?: boolean
  iconSize?: IconSize
  tag?: 'span' | 'div'
  truncateStart?: boolean
  noTruncate?: boolean
}>()

const isTruncated = computed(() => !truncateStart && !noTruncate)
</script>

<style lang="scss" scoped>
.external-link {
  min-width: 0;

  &__text {
    max-width: 100%;
  }

  &__icon {
    vertical-align: middle;
    transform: translateY(-2px);
    margin-left: 4px;
  }
}
</style>
